"use client";

import * as React from "react";
import styled, { css } from "styled-components";
import defaultTheme from "../../defaultTheme";
import { DEVICES, QUERIES } from "../../utils/mediaQuery/consts";
import mq, { getBreakpointWidth } from "../../utils/mediaQuery";
const StyledColumn = styled.div.withConfig({
  displayName: "LayoutColumn__StyledColumn",
  componentId: "sc-aa57pk-0"
})(["", ""], ({
  spanEntireRow,
  hideOn,
  theme
}) => css(["", ";", ";@media (max-width:", "px){.orbit-card{margin-right:-", ";margin-left:-", ";width:auto;}}"], Boolean(hideOn) && hideOn.length > 0 && Object.values(DEVICES).map(viewport => viewport in mq ? css(["", ";"], mq[viewport](css(["display:", ";"], hideOn.includes(viewport) && "none"))) :
// "smallMobile" is not media query so we need to check it explicitly
viewport === "smallMobile" && hideOn.includes(viewport) && css(["display:none;"])), spanEntireRow && css(["grid-column:1 / -1;"]), +getBreakpointWidth(QUERIES.LARGEMOBILE, theme, true) - 1, theme.orbit.spaceMedium, theme.orbit.spaceMedium));
StyledColumn.defaultProps = {
  theme: defaultTheme
};
const LayoutColumn = ({
  children,
  hideOn = [],
  as = "div",
  spanEntireRow,
  dataTest
}) => {
  return (
    /*#__PURE__*/
    /* @ts-expect-error: as */
    React.createElement(StyledColumn, {
      "data-test": dataTest,
      hideOn: hideOn,
      as: as,
      spanEntireRow: spanEntireRow
    }, children)
  );
};
export default LayoutColumn;